const entities = {
    attachment: 'Attachment',
    bankAccount: 'BankAccount',
    blacklist: 'Blacklist',
    checkoutPage: 'CheckoutPage',
    contact: 'Contact',
    coupon: 'Coupon',
    credential: 'Credential',
    customer: 'Customer',
    customField: 'CustomField',
    dispute: 'Dispute',
    gatewayAccount: 'GatewayAccount',
    invoice: 'Invoice',
    kycDocument: 'KycDocument',
    leadSource: 'LeadSource',
    organization: 'Organization',
    payment: 'Payment',
    paymentCard: 'PaymentCard',
    plan: 'Plan',
    product: 'Product',
    subscription: 'Subscription',
    transaction: 'Transaction',
    website: 'Website',
    tag: 'Tag',
    eventSpecific: 'EventSpecific',
};

export const entityToNamespace = {
    [entities.customer]: 'customers',
    [entities.customField]: 'customFields',
    [entities.gatewayAccount]: 'gatewayAccounts',
    [entities.invoice]: 'invoices',
    [entities.kycDocument]: 'kycDocuments',
    [entities.leadSource]: 'leadSources',
    [entities.organization]: 'organizations',
    [entities.company]: 'companies',
    [entities.plan]: 'plans',
    [entities.product]: 'products',
    [entities.subscription]: 'subscriptions',
    [entities.transaction]: 'transactions',
    [entities.website]: 'websites',
    [entities.tag]: 'tags',
};

export default entities;
